import { z } from 'zod';
import type { components } from '../types/Api';
import { zStringReq } from '@/utils/zStringReq';

export type UserProfile = components['schemas']['ProfileOut'];

export type EditableUserProfileData = components['schemas']['ProfileIn'];

export const userProfileSchema = z.object({
	firstName: zStringReq(),
	lastName: zStringReq(),
});

export const getPublisherIdForMerchant = (profile: UserProfile, merchantId: string): number | undefined => {
	const publisherId = profile.publisherIds[merchantId];

	if (!publisherId) {
		return undefined;
	}

	return publisherId;
};
